import { render, staticRenderFns } from "./cartRullingFriendly.vue?vue&type=template&id=2f3b43d8"
import script from "./cartRullingFriendly.vue?vue&type=script&lang=js"
export * from "./cartRullingFriendly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports